export const shouldRenderSupportPortal = ({ pathname, windows, android }) => (
  !windows && !android && pathname.startsWith("/soutien")
);
